

export default function divideTables() {
	// Get all elements with class "tables-small"
	const tables = document.querySelectorAll('.tables-small');

	if (!tables.length) return;
	console.log(tables.length);

	// Loop through each table
	tables.forEach(table => {
	  // Get the number of rows to divide the table into
	  const tablesCount = table.dataset.tables || 3;

	  // Create an array of rows
	  const rows = Array.from(table.querySelectorAll('tr'));

	  // Calculate the number of tables needed
	  const rowsPerTable = Math.ceil(rows.length / tablesCount);

	  console.log(rowsPerTable);
	  // Loop through the tables and divide the rows into them
	  for (let i = 0; i < tablesCount; i++) {
		// Create a new table element
		const newTable = document.createElement('table');

		// Add a class to the new table for styling purposes
		newTable.classList.add('tables-small__subtable');

		// Calculate the starting and ending indexes for the rows
		const start = i * rowsPerTable;
		const end = start + rowsPerTable;

		// Get the rows for this table
		const tableRows = rows.slice(start, end);

		// Append the rows to the new table
		tableRows.forEach(row => {
		  newTable.appendChild(row);
		});

		// Replace the original table with the new table
		if (i === 0) {
			table.replaceChild(newTable, table.querySelector('table'));
		} else {
			table.appendChild(newTable)

		}
	  }
	});
  }
